import * as React from "react";
import XDiv from "../../core/XDiv";

import { Button } from "../../core/Button";
import { CircularProgress, Stack } from "@mui/material";
import { TUseXElement } from "../../../hooks/useXElement";
import { COMPONENT_WITH_API_FETCH } from "../../../utils/constants/gui/componentChildren";

const XGUIDesignTab = React.lazy(() => import("../tabs/design"));

const XGUIDataTab = React.lazy(() => import("../tabs/data"));

const XGUIOrderElementsTab = React.lazy(() => import("../tabs/order"));

type TXGUITab =
  | "Apparence"
  | "Données"
  | "Ajouter un Element"
  | "Ordonner les Elements";

export const XGUIFieldContainer: React.FC<{
  selectedElement: TUseXElement<any>;
  setSelectedElement: any;
}> = ({ selectedElement, setSelectedElement }) => {
  const [tab, setTab] = React.useState<TXGUITab>("Apparence");

  const tabs: TXGUITab[] = ["Apparence"];

  if (COMPONENT_WITH_API_FETCH.includes(selectedElement.name)) {
    tabs.push("Données");
  }

  if (selectedElement.hasChildren || selectedElement.name === "XPage") {
    tabs.push("Ordonner les Elements");
  }

  React.useEffect(() => {
    if (!selectedElement.hasChildren && tab === "Ordonner les Elements") {
      setTab("Apparence");
    }

    if (
      !COMPONENT_WITH_API_FETCH.includes(selectedElement.name) &&
      tab === "Données"
    ) {
      setTab("Apparence");
    }
  }, [selectedElement.index]);

  return (
    <XDiv className="XGUI-Fields-Container">
      <XDiv className="XGUI-Fields-Tabs">
        {tabs.map((btn) => (
          <Button
            title={btn}
            key={btn}
            className={`XGUI-Fields-Tab${
              btn === tab ? " XGUI-Tab-Active" : ""
            }`}
            onClick={() => setTab(btn)}
          >
            {btn}
          </Button>
        ))}
      </XDiv>
      <XDiv
        className={`XGUI-Fields-List ${
          selectedElement.name === "XPage" ? "hasPage" : ""
        }`}
      >
        {tab === "Apparence" && (
          <React.Suspense
            fallback={
              <Stack
                height={380}
                width={370}
                alignItems="center"
                justifyContent="center"
              >
                <CircularProgress color="secondary" />
              </Stack>
            }
          >
            <XGUIDesignTab
              selectedElement={selectedElement}
              setSelectedElement={setSelectedElement}
            />
          </React.Suspense>
        )}

        {tab === "Données" && (
          <React.Suspense>
            <XGUIDataTab
              selectedElement={selectedElement}
              setSelectedElement={setSelectedElement}
            />
          </React.Suspense>
        )}

        {tab === "Ordonner les Elements" && (
          <React.Suspense>
            <XGUIOrderElementsTab
              selectedElement={selectedElement}
              setSelectedElement={setSelectedElement}
            />
          </React.Suspense>
        )}
      </XDiv>
    </XDiv>
  );
};
